import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getSystemSettings, updateSystemSettings } from "../../redux/actions/system";
import { setMessage } from "../../redux/actions/auth";

import Tabs from "../../components/Tabs/Tabs";
import FileUpload from "../../components/FileUpload/FileUpload";
import Hint from "../../components/Hint/Hint";
import DatePicker from "../../components/DatePicker/DatePicker";
import getDate from "../../helpers/getDate";
import WarningModal from "../../components/WarningModal/WarningModal";

const tabs = [
  {id: '1', name: 'Загальні  налаштування'},
  {id: '2', name: 'Кімнати'},
  {id: '3', name: 'Репутація'},
  {id: '4', name: 'Гаманець'},
  {id: '5', name: 'Промо'},
]

const SystemSettingsPage = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [form, setForm] = useState({});
  const [askPerm, setAskPerm] = useState(false);
  const { t } = useTranslation();
  const system = useSelector(state => state.system);
  const hint = useSelector(state => state.hints);
  
  const dispatch = useDispatch();

  const onChangeTab = (id) => {
    setActiveTab(id);
  };

  const onDelete = () => {
    setAskPerm(true);
  }
  const deleteApprove = () => {
     setAskPerm(false);
     dispatch(updateSystemSettings({}, 'settings-promo/clear-promo-db/')).then( res => {
        window.open(window.location.origin+res.downloadUrl, '_blank');
       dispatch(getSystemSettings());
     }).catch( e => {
       console.log(e);
     })
  }

  const changeHandler = (e) => {
    const { id, value } = e.target;
    const updatedForm = {};

    if (id === 'description' && value.length > 100) {
      return
    } else {
      updatedForm[id] = value;
    }

    setForm({...form, ...updatedForm});
  };

  const validateIsEmpty = () => {

    if (activeTab === '1') {
      return Object.keys(system.SettingsSystem).every( key => {
        const value = form[key];

        return value !== undefined && value !== null && value !== '';
      })
    }
    if (activeTab === '2') {
      return Object.keys(system.SettingsWallet).every( key => {
        const value = form[key];

        return value !== undefined && value !== null && value !== '';
      })
    }
    if (activeTab === '3') {
      return Object.keys(system.SettingsPoints).every( key => {
        const value = form[key];

        return value !== undefined && value !== null && value !== '';
      })
    }
    if (activeTab === '4') {
      return Object.keys(system.SettingsPayment).every( key => {
        const value = form[key];

        return value !== undefined && value !== null && value !== '';
      })
    }if (activeTab === '5') {
      return Object.keys(system.SettingsPromo).every( key => {
        const value = form[key];

        return value !== undefined && value !== null && value !== '';
      })
    }

  }

  const onSave = () => {
    if (!validateIsEmpty()) {
      dispatch(setMessage({
        message: 'Заповніть всі поля',
        type: 'error',
      }))

      return
    };

    const data = {};

    if (activeTab === '1') {
      data.name = form.name;
      data.description = form.description;
      data.email = form.email;
      data.favicon = form.favicon;
      data.metaImage = form.metaImage;

      updateData(data, 'settings-system/')
    }

    if (activeTab === '2') {
      if(form.maximumCost!=0 && form.minimumCost>form.maximumCost){
        dispatch(setMessage({
          message: 'Максимальна вартість не може бути меншою за мінімальну',
          type: 'error',
        }))
        return
      } 
      data.commissionAmount = form.commissionAmount;
      data.lowerLimitToken = form.lowerLimitToken;
      data.minimumCost = form.minimumCost;
      data.maximumCost = form.maximumCost;
      data.countdownSystemReadiness = form.countdownSystemReadiness;
      data.soundReadiness = form.soundReadiness;
      data.soundStart = form.soundStart;
      data.rules = form.rules;

      updateData(data, 'settings-wallet/')
    }

    if (activeTab === '3') {
      data.exitsRoomsRow = form.exitsRoomsRow;
      data.exitsRoomsDay = form.exitsRoomsDay;
      data.readyNotPressingButton = form.readyNotPressingButton;
      data.dayNotPressingButton = form.dayNotPressingButton;
      data.gamesWithoutPenalties = form.gamesWithoutPenalties;
      updateData(data, 'settings-points/');
    }
    if (activeTab === '4') {
      data.feeCrypto = +form.feeCrypto;
      data.feeFiat = +form.feeFiat;
      data.cryptoWithdraw = +form.cryptoWithdraw;
      data.fiatWithdraw = +form.fiatWithdraw;
      data.cryptoAdd = +form.cryptoAdd;
      data.fiatAdd = +form.fiatAdd;
      updateData(data, 'settings-payment/');
    }
    if (activeTab === '5') {
      let datastartRegistartion = getDate(form.startRegistartion,'dd/mm/yyyy hh:mm','.');
      let datastartActive = getDate(form.startActive,'dd/mm/yyyy hh:mm','.');
      let datafinishActive = getDate(form.finishActive,'dd/mm/yyyy hh:mm','.');
      if( new Date(datastartRegistartion).getTime()>new Date(datastartActive).getTime() || new Date(datastartRegistartion).getTime()>new Date(datafinishActive).getTime() || new Date(datastartActive).getTime()>new Date(datafinishActive).getTime()){ 
        dispatch(setMessage({
          message: 'Перевірте коректність введених дат',
          type: 'error',
        }))
        return
      }
      data.isPromo = form.isPromo;
      data.startRegistartion = datastartRegistartion;
      data.startActive = datastartActive;
      data.finishActive = datafinishActive;
      data.amountAdded = +form.amountAdded;
      updateData(data, 'settings-promo/');
    }
  };

  const updateData = (data, url) => {
    dispatch(updateSystemSettings(data, url)).then( res => {
      dispatch(getSystemSettings());
    }).catch( e => {
      console.log(e);
    })
  }

  const onReset = () => {
    setForm({
      ...system.SettingsSystem,
      ...system.SettingsPoints,
      ...system.SettingsWallet,
      ...system.SettingsPayment,
      ...system.SettingsPromo,
    })
  };

  useEffect(() => {
    if (system) {
      setForm({
        ...system.SettingsSystem,
        ...system.SettingsPoints,
        ...system.SettingsWallet,
        ...system.SettingsPayment,
        ...system.SettingsPromo
      });
    }
  }, [system])

  return (
    <>
      <div className="profileSection" style={{marginBottom:'0px'}}>
        <div className="prFlexRow profileSectionHeader" style={{marginBottom:'40px'}}>
          <h2>Налаштування системи
            <div className="infoHelp"> <Hint align='left' item={hint[39]}/></div>
          </h2>
        </div>

        <div className="systemSettings">
          <div className="">
            <Tabs tabs={tabs} onChangeTab={onChangeTab} activeTab={activeTab}/>
          </div>

          <div className="flexCol">
            {activeTab === "1" && (
              <div className="prflexColumn" style={{ gap: '70px' }}>
                <div className="prFlexRow systemSettingsInputs" style={{ gap: '20px', width: '100%' }}>
                  <div style={{ width: '100%', alignSelf: "flex-start" }}>
                    <div className="prInput">
                      <label htmlFor="name" className="prInputLabel">Назва системи</label>
                      <input
                        id="name"
                        type="text"
                        className="prInputInput"
                        value={form.name || ''}
                        onChange={changeHandler}
                        placeholder="Назва системи"
                      />
                    </div>
                    <div className="prInput">
                      <label htmlFor="email" className="prInputLabel">Пошта для повідомлень</label>
                      <input
                        id="email"
                        type="text"
                        className="prInputInput"
                        value={form.email || ''}
                        onChange={changeHandler}
                        placeholder="Пошта для повідомлень"
                      />
                    </div>
                    <div className="prInput">
                      <label htmlFor="description" className="prInputLabel">Опис системи</label>
                      <input
                        id="description"
                        type="text"
                        className="prInputInput"
                        value={form.description || ''}
                        onChange={changeHandler}
                        placeholder="Опис системи"
                      />
                      <span
                        style={{
                          marginTop: '4px',
                          fontSize: '14px',
                          color: 'var(--Text)', 
                          alignSelf: 'flex-end',
                        }}
                      >
                        {form.description && form.description.length}/100
                      </span>
                    </div>
                  </div>
                  
                  <div style={{ width: '100%', alignSelf: "flex-start" }}>
                    <div className="prInput">
                      <label htmlFor="favicon" className={"prInputLabel"}>
                        Favicon
                      </label>
                      <FileUpload id={'favicon'} imageUrl={form.favicon || ''} form={form} setForm={setForm} url='uploads/favicon'></FileUpload>
                    </div>
                    <div className="prInput">
                      <label htmlFor="metaImage" className={"prInputLabel"}>
                        Метазображення
                      </label>
                      <FileUpload id={'metaImage'} imageUrl={form.metaImage || ''} form={form} setForm={setForm} url='uploads/meta-img'></FileUpload>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "2" && (
              <div className="prflexColumn">
                <div className="prInput">
                  <label htmlFor="commissionAmount" className="prInputLabel">{t('Розмір відсотка, який отримує Арбітр в Кімнаті')}</label>
                  <input
                    id="commissionAmount"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.commissionAmount || ''}
                  />
                </div>
                {/* <div className="prInput">
                  <label htmlFor="lowerLimitToken" className="prInputLabel">{t('Нижня межа на виведення Токенів')}</label>
                  <input
                    id="lowerLimitToken"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.lowerLimitToken || ''}
                  />
                </div> */}
                <div className="prInput">
                  <label htmlFor="minimumCost" className="prInputLabel">{t('Мінімальна вартість участі в кімнаті')}</label>
                  <input
                    id="minimumCost"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.minimumCost || ''}
                  />
                </div>
                <div className="prInput">
                  <label htmlFor="maximumCost" className="prInputLabel">{t('Максимальна вартість участі в кімнаті, якщо 0, то без обмеження')}</label>
                  <input
                    id="maximumCost"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.maximumCost || ''}
                  />
                </div>
                <div className="prInput">
                  <label htmlFor="countdownSystemReadiness" className="prInputLabel">{t('Строк зворотного відліку для системи готовності в секундах')}</label>
                  <input
                    id="countdownSystemReadiness"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.countdownSystemReadiness || ''}
                  />
                </div>
                <div className="prInput">
                  <label htmlFor="soundReadiness" className="prInputLabel">{t('Час до сигналу нагадування про готовність')}</label>
                  <input
                    id="soundReadiness"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.soundReadiness || ''}
                  />
                </div>
                <div className="prInput">
                  <label htmlFor="soundStart" className="prInputLabel">{t('Час до сигналу нагадування про початок гри')}</label>
                  <input
                    id="soundStart"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.soundStart || ''}
                  />
                </div>
                <div className="prInput">
                    <label htmlFor="rules" className="prInputLabel">
                      {t("Правила кімнати")}
                    </label>
                    <textarea
                      onChange={changeHandler}
                      id="rules"
                      value={form?.rules || ""}
                      placeholder={t("enter_value")}
                      cols="30"
                      rows="10"
                    ></textarea>
                  </div>
              </div>
            )}

            {activeTab === "3" && (
              <div className="prflexColumn">
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="exitsRoomsRow"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.exitsRoomsRow || ''}
                  />
                  <span> виходи з Кімнати поспіль - 1 бал</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="exitsRoomsDay"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.exitsRoomsDay || ''}
                  />
                  <span> виходи з Кімнати впродовж доби - 2 бали</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="readyNotPressingButton"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.readyNotPressingButton || ''}
                  />
                  <span> ненатискання кнопки готовності поспіль - 1 бал</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="dayNotPressingButton"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.dayNotPressingButton || ''}
                  />
                  <span> ненатискань кнопки готовності впродовж доби - 2 бали</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="gamesWithoutPenalties"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.gamesWithoutPenalties || ''}
                  />
                  <span> ігор без штрафних санкцій +1 бал</span>
                </div>
              </div>
            )}
            {activeTab === "4" && (
              <div className="prflexColumn">
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="feeCrypto"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.feeCrypto || ''}
                  />
                  <span> комісія Криптокоіна в %</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="feeFiat"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.feeFiat || ''}
                  />
                  <span> комісія Фіаткоіна в %</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="cryptoWithdraw"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.cryptoWithdraw || ''}
                  />
                  <span> мінімальна сума виведення Криптокоіна</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="fiatWithdraw"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.fiatWithdraw || ''}
                  />
                  <span> мінімальна сума виведення Фіаткоіна</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="fiatAdd"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.fiatAdd || ''}
                  />
                  <span> мінімальна сума поповнення Фіаткоіна</span>
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="cryptoAdd"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.cryptoAdd || ''}
                  />
                  <span> мінімальна сума поповнення Криптокоіна</span>
                </div>
              </div>
            )}
            {activeTab === "5" && (
              <div className="prflexColumn">
                <div className="prInput">
                  <label htmlFor="isPromo" className={"prInputLabel"}>
                    {t("is_promo")}
                  </label>
                  <label className="switch">
                    <input
                      type="checkbox"
                      id="isPromo"
                      checked={form.isPromo==1}
                      onChange={() => setForm({ ...form, isPromo: form.isPromo?0:1 })}
                    />
                    <span className="slider round"></span>
                      {form.isPromo==1?<span className="switchText left">Так</span>:
                    <span className="switchText right">Ні</span>}
                  </label>
                </div>
                { form.isPromo==1&&<>
                <div className="prInput">
                  <label htmlFor="startRegistartion" className={ "prInputLabel"}>{t("startRegistartion")}</label>
                  <DatePicker id='startRegistartion' time={true}  onChange={changeHandler} icon={true} value={getDate(form.startRegistartion,'dd/mm/yyyy hh:mm','.')} />
                </div>
                <div className="prInput">
                  <label htmlFor="startActive" className={ "prInputLabel"}>{t("startActive")}</label>
                  <DatePicker id='startActive'  time={true} onChange={changeHandler} icon={true} value={getDate(form.startActive,'dd/mm/yyyy hh:mm','.')} />
                </div>
                <div className="prInput">
                  <label htmlFor="finishActive" className={ "prInputLabel"}>{t("finishActive")}</label>
                  <DatePicker id='finishActive'  time={true} onChange={changeHandler} icon={true} value={getDate(form.finishActive,'dd/mm/yyyy hh:mm','.')} />
                </div>
                <div className="smallInput" style={{marginBottom:'30px'}}> 
                  <input
                    id="amountAdded"
                    className="prInputInput"
                    type="number"
                    min={0}
                    onChange={changeHandler}
                    value={form.amountAdded || ''}
                  />
                  <span> Кількість токенів, які начисляються новому користувачу автоматично після реєстрації</span>
                </div>
                  <button style={{marginBottom:'20px'}} className="prButton prButtonSecond" onClick={onDelete}>Очистити базу даних промо серверу</button>
                </>}
              </div>
            )}

            <div className="userEditButtons" style={{ alignSelf: 'center' }}>
                <button className="prButton prButtonSecond" onClick={onReset}>{t('cancel')}</button>
                <button
                  className="prButton prButtonMain"
                  onClick={onSave}
                >
                  Зберегти
                </button>
            </div>
          </div>

        </div>
      </div>
      {askPerm &&
        <WarningModal warningClick={deleteApprove} warningText={'are_you_sure_delete'} warningButton={'delete'} closeClick={()=>setAskPerm(false)}></WarningModal>
      }
    </>
  )
}

export default SystemSettingsPage;